<p *ngIf="LABELS?.TITLE">
	<strong>{{ LABELS?.TITLE }}</strong>
</p>

<p class="u-text--sm u-text--xlight u-m-top--tiny">
	<ng-content></ng-content>
</p>

<div>
	<div *ngFor="let file of currentFiles" class="c-file__item u-m-top--sm">
		<tvcore-icon name="file"></tvcore-icon>
		<span class="flex--1"
			>{{ file.file.name }} <ng-container *ngIf="file.file?.size">({{ getSize(file.file) }})</ng-container></span
		>
		<tvcore-icon class="remove-icon" name="close" (click)="removeFile(file)"></tvcore-icon>
	</div>
</div>

<p *ngIf="error" class="u-text--sm u-text--error u-m-top--sm">{{ error }}</p>

<div *ngIf="!hideUpload" class="c-file-selector u-m-top--sm" [class.c-file-selector--error]="showErrors && hasError()" [class.c-file-selector--dragging]="dragging">
	<div class="c-file-selector__button flex-row">
		<tvcore-icon name="paperclip"></tvcore-icon>
		<p class="u-m-left--xxs">{{ LABELS?.ADD_BUTTON }}</p>
	</div>

	<p class="u-text--sm u-text--light u-m-top--xxs">
		{{ LABELS?.TEXT }}
	</p>

	<input #uploadInput type="file" [accept]="acceptedFileTypes" (change)="fileSelect($event)" (dragenter)="dragging = true" (dragleave)="dragging = false" />
</div>

<p *ngIf="showErrors && hasError()" class="u-text--sm u-text--error u-m-top--sm">{{ LABELS?.ERROR_REQUIRED }}</p>
